import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { initializeFirebaseApp } from './lib/firebase';
import { App } from './app';
import './index.css';

initializeFirebaseApp();

async function boot() {
  if (__USE_LOCAL_AUTH__) {
    const { devAutoLogin } = await import('./lib/dev-auto-login');
    await devAutoLogin();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
